import Swiper from 'swiper';

const imageSliderParams = {
  direction: 'horizontal',
  allowTouchMove: false,
  loop: true,
  effect: 'slide',
  breakpoints: {
    900: {
      direction: 'vertical'
    }
  }
};

const imageSwiper = new Swiper('.hero__images', imageSliderParams);

const measureContentSliderParams = {
  direction: 'horizontal',
  allowTouchMove: true,
  loop: true,
  speed: 1000,
  effect: 'slide',
  pagination: {
    el: '.hero__measures__pagination'
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    900: {
      direction: 'vertical'
    }
  }
};

const measureContentSlider = new Swiper('.hero-content__measures-slider', measureContentSliderParams);

if (measureContentSlider.controller) {
  measureContentSlider.controller.control = imageSwiper;
}
